import React, { useState, useEffect } from 'react';
import Loader from '../../Search/Loader';

const ChampionshipStandingsTable = ({ championship, permalink}) => {
    const [loading, setLoading] = useState(true);
    const [championshipId, setChampionshipId] = useState(championship);
    const [standingsData, setStandingsData] = useState([]);
    const [viewAll, setViewAll] = useState(false);

    useEffect(() => {
        fetch(`${wp_ajax.db_ajax_url}?action=fetch_database_championship_standings&championship_id=${championshipId}`)
            .then(res => res.json())
            .then(response => {
                setStandingsData(response.data);
                setLoading(false);

                if (response.data.length <= 3) {
                    setViewAll(true);
                }
            });
    }, []);

    if (loading) {
        return <Loader />;
    }

    const standingsDataResults = () => {
        if (viewAll) {
            return standingsData;
        }

        return standingsData.slice(0, 3);
    };

    const movementCss = result => {
        let baseCssClass = 'database-table__';
        return result.movement > 0 ? `${baseCssClass}up` : `${baseCssClass}down`;
    };

    return (
        <div className="database-table-collapsible__table">
            <table className="database-table database-table--striped">
                <thead>
                    <tr className="proxima">
                        <th>Driver</th>
                        <th>Standing</th>
                        <th>Team</th>
                        <th className="u-hidden-mobile">Nationality</th>
                        <th>Points</th>
                    </tr>
                </thead>
                <tbody>
                    {standingsData.length > 0 &&
                        standingsDataResults().map((result, i) => (
                            <tr key={i}>
                                <td className="database-table__td--less-pad">
                                    <div className="database-table__group">
                                        <div
                                            className="circular-image circular-image--small"
                                            dangerouslySetInnerHTML={{ __html: result.driver_image }}></div>
                                        <p className="database-table__title">
                                            <a href={result.driver_url}>{result.driver_name}</a>
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <p className="database-table__counter proxima">{result.standing}</p>
                                </td>
                                <td>
                                    {result.entrants.length > 0 &&
                                        result.entrants.map((entrant, ei) => (
                                            <p className="database-table__title" key={ei}>
                                                <a href={entrant.team_url}>{entrant.team_name}</a>
                                            </p>
                                        ))}
                                    {result.entrants.length <= 0 && (
                                        <p className="database-table__title">
                                            <a href={result.team_url}>{result.team_name}</a>
                                        </p>
                                    )}
                                </td>
                                <td
                                    className="u-hidden-mobile"
                                    dangerouslySetInnerHTML={{ __html: result.country.flag }}></td>
                                <td>
                                    <p className="database-table__counter proxima">{result.points}</p>
                                </td>
                            </tr>
                        ))}
                    {standingsData.length < 1 && (
                        <tr>
                            <td colSpan="7">No results available in the database</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {!viewAll && (
                <>
                    <br />
                    { permalink ? (
                        <a href={permalink} className="button button--outline">
                            View all results
                        </a>
                    ) : (
                        <a onClick={() => setViewAll(true)} className="button button--outline">
                            View all results
                        </a>
                    ) }
                </>
            )}
            
            { permalink && viewAll ? (
                <>
                    <br />
                    <a href={permalink} className="button button--outline">
                        View more
                    </a>
                </>
            ): '' }
        </div>
    );
};

export default ChampionshipStandingsTable;
